import { render, staticRenderFns } from "./ServiceDelete.vue?vue&type=template&id=0b43c83b&scoped=true&"
import script from "./ServiceDelete.vue?vue&type=script&lang=js&"
export * from "./ServiceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43c83b",
  null
  
)

export default component.exports